import React from "react";
import { HeadlineCardsWide } from "../cards/HeadlineCard";
import SectionImageTitle from "../cards/SectionImage&Title";

export default function MultiColumn({ sections, sectionStories }) {
  const filterData = (name) => {
    // Use sectionStories data directly
    if (sectionStories && sectionStories[name]) {
      const sectionData = sectionStories[name];

      // Transform the data to match the expected format (story.story)
      const transformedStories = sectionData.stories.map((story) => ({
        story: story,
        id: story.id || story.slug,
      }));

      return {
        section_name: name,
        slug: `/${name.toLowerCase().replace(/\s+/g, "-")}`,
        items: transformedStories.slice(0, 3),
      };
    }

    // Return empty data if no sectionStories data
    return {
      section_name: name,
      slug: "",
      items: [],
    };
  };
  const section0Data = filterData(sections[0]);
  const section1Data = filterData(sections[1]);
  const section2Data = filterData(sections[2]);
  const section3Data = filterData(sections[3]);
  const section4Data = filterData(sections[4]);
  const section5Data = filterData(sections[5]);

  const topCol = [section3Data, section4Data];
  const bottomCol = [section0Data, section1Data, section2Data];
  const leftCol = section5Data;

  return (
    <div className="mt-9 flex flex-col gap-4 mobile:mt-4">
      <div className="flex gap-4 mobile:flex-col">
        <div className="flex w-[67%] gap-8 mobile:w-[100%] mobile:flex-col">
          {topCol.map((item, index) => (
            <div className="flex w-[50%] flex-col gap-3 mobile:w-[100%]" key={index}>
              <SectionImageTitle section={item.items} slug={item.slug} title={item.section_name} />
            </div>
          ))}
        </div>
        <HeadlineCardsWide sectionName={leftCol.items} slug={leftCol.slug} title={leftCol.section_name} />
      </div>
      <div className="mt-5 flex mobile:w-[100%] mobile:flex-col">
        <div className="flex w-[100%] gap-8 mobile:flex-col">
          {bottomCol.map((item, index) => (
            <div className="flex w-[33.3%] flex-col gap-3 mobile:w-[100%]" key={index}>
              <SectionImageTitle section={item.items} slug={item.slug} title={item.section_name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
